export { default as selectGoodsService } from './select-goods-service'
